import Aos from "aos";
import "aos/dist/aos.css";

import React, { useEffect } from "react";
const About = () => {
  useEffect(() => {
    Aos.init({
      duration: 2000,
    });
  }, []);

  return (
    <div className=" bg-secondary p-10">
      <div
        data-aos="fade-down"
        className="grid lg:grid-cols-2 items-center h-[100vh] gap-x-10"
      >
        <div className="shadow-xl bg-accent rounded-lg">
          <img
            src="https://i.ibb.co/w69nwFZ/habibullah.png"
            alt="habibullah"
            className="w-2/3 mx-auto "
          />
        </div>
        <div className="p-5">
          <h1 className="text-2xl font-bold text-base-100">
            <span className="text-primary uppercase">About Me</span>
          </h1>{" "}
          <hr className="mt-2" />
          <p className="text-justify text-base-100 text-lg mt-5">
            I am a Frontend Developer with expertise in React, Node.js,
            Express.js, and MongoDB. I also build static websites using HTML5,
            CSS3, and JavaScript (ES6). I prioritize continuous learning and
            staying up-to-date with emerging technologies.
          </p>
          <p className="text-base-100 mt-5 text-lg">
            Recently, I've been exploring a few technologies as part of my work
          </p>{" "}
          <hr className="mt-2" />
          <div className="mt-5 text-base-100">
            <h1 className="text-xl text-primary font-bold uppercase">
              Frontend
            </h1>
            <p className="mt-2 font-bold">
              HTML5 | CSS3 | Bootstrap | Tailwind | Daisy UI | Javascript(ES6) |
              React.js | React Bootstrap | WordPress | Elementor
            </p>
          </div>
          <div className="mt-5 text-base-100">
            <h1 className="text-xl text-primary font-bold uppercase">
              Backend
            </h1>
            <p className="mt-2 font-bold">Node.js | Express.js | MongoDB</p>
          </div>
          <div className="mt-5 text-base-100 ">
            <h1 className="text-xl text-primary font-bold uppercase">Tools</h1>
            <p className="mt-2 font-bold">
              VS Code | Git | Firebase | NPM | Render | Vercel | Chrome Dev Tool
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
